import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import SvgIcon from '../common/SvgIcon.vue';
import { ICON_NAME } from '../../../constants/icon';

interface Props {
  audioVolume?: number,
  isMuted?: boolean,
  size?: string,
  isDisabled?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioIcon',
  props: {
    audioVolume: null,
    isMuted: { type: Boolean },
    size: null,
    isDisabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  audioVolume?: number,
  isMuted?: boolean,
  size?: string,
  isDisabled?: boolean,
}



const iconName = computed(() => {
  if (props.isDisabled) {
    return ICON_NAME.MicOffDisabled;
  }
  return props.isMuted ? ICON_NAME.MicOff : ICON_NAME.MicOn;
});

const showAudioLevel = computed(() => {
  if (props.isMuted || !props.audioVolume) {
    return 0;
  }
  return ((props.audioVolume * 4) / 100) * 5;
});


return { __sfc: true,props, iconName, showAudioLevel, SvgIcon }
}

})